import { css, keyframes } from 'styled-components';
import { primitiveColors } from '@/core/tokens/designs/default';

export {
	primitiveColors,
	padding,
	radius,
	boxShadow,
	font,
	fontSnippets,
	gradient,
} from '@/core/tokens/designs/default';

/**
 * Единый стиль фокус-ринга для клавиатурной навигации.
 *
 * Использует `:focus-visible`, а не `:focus`: мышиный клик кольца не
 * рисует, при навигации `Tab` / `Shift+Tab` — рисует. Цвет — брендовый
 * primary, толщина 2px + 2px offset, чтобы быть заметным на любом фоне
 * (включая `transparent` IconButton поверх цветного хедера профиля).
 *
 * Глобальный `outline: 0` в `src/styles/global.ts` сбрасывает дефолтный
 * браузерный ring у всех `button`/`input` — поэтому каждый
 * интерактивный элемент должен явно подмешать этот миксин (или дать
 * свой эквивалентный focus-стиль). См. `.cursor/rules/accessibility.mdc`.
 */
export const focusRing = css`
    &:focus { outline: none; }
    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.brand?.primary ?? primitiveColors.primary[500]};
        outline-offset: 2px;
    }
`;

export const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1170px',
    laptopL: '1440px',
    desktop: '2560px'
}

export const device = {
    mobileS: `(min-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    tablet: `(min-width: ${size.tablet})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktop})`
};

export const elementSize = {
    headerHeight: '10rem',
    mobileHeaderHeight: '70px',
}
export const transition = {
    fastEnd: '0.4s cubic-bezier(.91,.8,.27,1.19)'
}

export const fadeIn = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const appearanceAnimation = keyframes`
    0% { transform: scale(0.9); opacity: 0 }
    50% { transform: scale(1.1); opacity: .7; }
    100% { transform: scale(1); opacity: 1 }
`;

export const slideIn = keyframes`
    0% {transform: scale(1,1) translateY(100%);}
    10% {transform: scale(1.1,.9) translateY(50%);}
    30% {transform: scale(.9,1.1) translateY(0);}
    50% {transform: scale(1) translateY(7px);}
    100% {transform: scale(1) translateY(0);}
`;

export const Spin = keyframes`
    0% {
        -webkit-transform: rotate(0deg) scale(1);
        transform: rotate(0deg) scale(1);
    }

    50% {
        -webkit-transform: rotate(360deg) scale(1.3);
        transform: rotate(360deg) scale(1.3);
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
`;

export const AnimatedAppearance = css`
    animation: ${fadeIn} 0.5s ease-in-out forwards;
`;

